import React from 'react'

import { Avatar } from 'antd'

export const AgentLoaderItem: React.FC = () => {
   return (
      <div className="flex items-end justify-end gap-x-2">
         <div className="flexc justify-between bg-[#594180] py-4 px-8 max-w-[450px] rounded-3xl rounded-br-none gap-y-1">
            <div>
               <span className="loading-dots text-[50px] h-7 overflow-hidden flexc">
                  <span className="dot">.</span>
                  <span className="dot">.</span>
                  <span className="dot">.</span>
               </span>
            </div>
         </div>
         <Avatar
            src={'/images/ff_white.png'}
            className="w-10 h-10 p-1 bg-primary/10"
         ></Avatar>
      </div>
   )
}
